import OrganizationApi from '../../api/organization';
import UserSelect from './UserSelect';

class PracticeAdminSelect extends UserSelect {
    componentDidMount() {
        const orgId = this.props.organization;
        const practiceId = this.props.practice.id;
        this.loadOptions(orgId, practiceId);
    }

    componentWillReceiveProps(newProps) {
        // update selected with the new val...
        if (newProps.practice.id !== this.props.practice.id) {
            this.setState({ selected: newProps.value });
            this.loadOptions(newProps.organization, newProps.practice.id);
        }
    }

    loadOptions(orgId, practiceId) {
        OrganizationApi.getPracticeAdmins(orgId, practiceId).then(members => {
            let userOpts = [];
            if (Array.isArray(members)) {
                members.forEach(member => {
                    let label = member.email;
                    if (member.name && member.name !== ' ') {
                        label = `${member.name} (${member.email})`;
                    }
                    userOpts.push({
                        value: member.email,
                        label: label,
                    });
                });
            }
            this.setState({ options: userOpts });
        });
    }

    getNewItemLabel(option) {
        return `Invite ${option} as a Practice Administrator`;
    }
}

export default PracticeAdminSelect;
